<script>
import i18n from "../i18n";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
import Button from "@/components/c-button";
/* eslint-disable no-console */
/**
 * Customer Partner component
 */
export default {
  data() {
    return {
      dataIndex: 0,
      dataPartnerName: this.partner == null ? '' : this.partner.partner_name,
      dataPartnerNameEn: this.partner == null ? '' : this.partner.partner_name_en,
      dataPartnerType: this.partner == null ? '' : this.partner.partner_have_to,
      dataPartnerSex: this.partner == null ? 0 : this.partner.partner_sex,
      dataPartnerPhone: this.partner == null ? '' : this.partner.partner_phone_no,
      dataPartnerIDType: this.partner == null ? 0 : this.partner.partner_id_type,
      dataPartnerIDNo: this.partner == null ? '' : this.partner.partner_id_no,
      dataPartnerIDDate: this.partner == null ? '' : this.partner.partner_id_date,
      dataPartnerNationality: this.partner == null ? 0 : this.partner.partner_nationality_id,
      dataPartnerDOB: this.partner == null ? '' : this.partner.partner_dob,
      id: this.partner == null ? 0 : this.partner.id,
    };
  },
  components: { Input, Select, Button },
  mounted() {},
  props: {
    partner: null,
    index: {
      type: Number,
      default: 0
    },
    idTypeData: [],
    nationalityData: [],
    sexData: [],
    disabled: {
      default: false
    },
  },
  methods: {
    translate: function(name) {
      return i18n.t(name);
    },

    getPartner: function() {
      if(this.dataPartnerName == null && this.dataPartnerType == null &&
        this.dataPartnerNameEn == null && this.dataPartnerSex == null &&
        this.dataPartnerPhone == null && this.dataPartnerIDType == null && 
        this.dataPartnerIDNo == null && this.dataPartnerIDDate == null && 
        this.dataPartnerNationality == null && this.dataPartnerDOB == null) {
          return null;
        } else {
          return {
            id: this.id,
            partner_name: this.dataPartnerName,
            partner_name_en: this.dataPartnerNameEn,
            partner_have_to: this.dataPartnerType,
            partner_sex: this.dataPartnerSex,
            partner_phone_no: this.dataPartnerPhone,
            partner_id_type: this.dataPartnerIDType,
            partner_id_no: this.dataPartnerIDNo,
            partner_id_date: this.dataPartnerIDDate,
            partner_nationality_id: this.dataPartnerNationality,
            partner_dob: this.dataPartnerDOB
          };
        }
      
    }
  },

};
</script>
<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-lg-10">
          <h4 class="card-title mb-4">{{`${$t('customer.partner-info-no')} ${index}`}}</h4>
        </div>
        <div v-show="!disabled" class="col-lg-2">
          <Button v-bind:icon="'bx bx-trash-alt'" 
                v-bind:buttonType="'button'"
                v-bind:variant="'danger'"
                @click="$emit('remove', index, id)" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <Input 
              :type="'text'"
              :id="`partner_name_${index}`"
              :disabled="disabled"
              v-model="dataPartnerName"
              :label="'customer.name'"  />
        </div>
        <div class="col-md-6">
          <Input 
              :type="'text'"
              :id="`partner_name_en_${index}`"
              :disabled="disabled"
              v-model="dataPartnerNameEn"
              :label="'customer.name-en'"  />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <Input 
              :type="'text'"
              :id="`partner_have_to_${index}`"
              :disabled="disabled"
              v-model="dataPartnerType"
              :label="'customer.partner-type'"  />
        </div>
        <div class="col-md-6">
          <Select 
              :id="`partner_sex_id_${index}`"
              :disabled="disabled"
              v-model="dataPartnerSex"
              :list="this.sexData"
              :label="'customer.gender'"  />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
            <Input 
              :type="'text'"
              :id="`partner_phone_no_${index}`"
              :disabled="disabled"
              v-model="dataPartnerPhone"
              :mask="'### ### ########'"
              :label="'customer.phone-no'"  />
          </div>
        <div class="col-md-6">
          <Select 
              :id="`partner_id_type_${index}`"
              :disabled="disabled"
              v-model="dataPartnerIDType"
              :list="this.idTypeData"
              :label="'customer.id-type'"  />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <Input 
            :type="'text'"
            :id="`partner_id_no_${index}`"
            :disabled="disabled"
            v-model="dataPartnerIDNo"
            :label="'customer.id-no'"  />
        </div>
        <div class="col-md-6">
          <Input 
            :type="'date'"
            :id="`partner_id_date_${index}`"
            :disabled="disabled"
            v-model="dataPartnerIDDate"
            :label="'customer.id-date'"  />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <Select 
              :id="`partner_nationality_id_${index}`"
              :disabled="disabled"
              v-model="dataPartnerNationality"
              :list="this.nationalityData"
              :label="'customer.nationality'"  />
          
        </div>
        <div class="col-md-6">
          <Input 
            :type="'date'"
            :id="`partner_dob_${index}`"
            :disabled="disabled"
            v-model="dataPartnerDOB"
            :label="'customer.dob'"  />
        </div>
      </div>
    
    </div>
  </div>
</template>